class BuildYourBundleCart extends HTMLElement {
  constructor() {
    super(),
      (this.collectionId = this.dataset.collection),
      (this.translations = this.extractTranslations()),
      (this.currency = window.Shopify.currency.active),
      (this.errorMessage = null),
      (this.productsInBundle = []),
      (this.bundleQuantity = 0),
      (this.bundleName = ""),
      (this.selectedVariant = null),
      (this.bundlePrice = 0),
      (this.mhkd = 0),
      (this.cpp = 0),
      (this.mpc = 0),
      (this.mpcd = 0),
      (this.overlay = document.getElementById("byb_overlay")),
      (this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer")),
      (this.facet = document.querySelector("byb-facet-filters-form")),
      this.onLoad(),
      (this.closeButton = document.getElementById("close-byb-cart")),
      (this.openButton = document.getElementById("open-byb-cart")),
      this.closeButton.addEventListener("click", () => this.toggleCart()),
      this.openButton.addEventListener("click", () => this.toggleCart()),
      window.addEventListener("scroll", () => {
        !this.classList.contains("hidden") &&
          this.isMobile() &&
          this.toggleCart();
      }),
      document.addEventListener("click", (event) => {
        event.target.classList.contains("byb-bundle-item-empty") &&
          this.toggleCart();
      });
  }
  hideOverlay() {
    this.overlay && this.overlay.classList.add("!hidden");
  }
  isMobile() {
    return window.innerWidth <= 768;
  }
  async onLoad() {
    this.formCatch(),
      await this.fetchDiscounts(),
      this.insertBundleQuantity(),
      this.insertBundleQuantityInUspGrid(),
      this.insertBundlePriceInUspGrid(),
      this.updateBundleUI(),
      this.disableLoading();
  }
  formCatch() {
    this.forms && this.forms.length > 0,
      (this.forms = document.getElementsByClassName("bundle-form"));
    for (let i = 0; i < this.forms.length; i++)
      this.forms[i].addEventListener("submit", async (event) => {
        event.preventDefault(),
          await this.addToCart(event, this.forms[i]),
          this.productsInBundle.length === this.bundleQuantity &&
            this.toggleCart();
      });
  }
  handleIntersectionAfterSubmit() {
    const animationTriggerElements = Array.from(
      document.querySelectorAll(`.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`)
    );
    animationTriggerElements.forEach((element) => {
      if (
        element.isIntersecting &&
        element.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME) &&
        (element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),
        element.hasAttribute("data-cascade"))
      ) {
        const index = animationTriggerElements.indexOf(element);
        element.setAttribute("style", `--animation-order: ${index};`);
      }
    });
  }
  insertBundleQuantityInUspGrid() {
    document.querySelectorAll(".bundle-qty").forEach((bundleQtyElement) => {
      bundleQtyElement.textContent = this.bundleQuantity;
    });
  }
  insertBundlePriceInUspGrid() {
    const uspGridElement = document.querySelector(".usp-grid");
    uspGridElement &&
      uspGridElement
        .querySelectorAll(".bundle-price")
        .forEach((bundlePriceElement) => {
          bundlePriceElement.textContent = `${this.bundlePrice*Shopify.currency.rate} ${this.currency}`;
        });
  }
  insertBundleQuantity() {
    const qtyElement = document.querySelector(".byb-qty");
    qtyElement && (qtyElement.textContent = this.bundleQuantity);
  }
  addToCart(event, form) {
    if (this.productsInBundle.length >= this.bundleQuantity) return;
    const formData = new FormData(form),
      c = this.extractHkd(formData),
      selectedOption = form.querySelector('select[name="id"] option:checked'),
      variantTitle = selectedOption
        ? selectedOption.getAttribute("data-variant-title")
        : "",
      product = {
        id: formData.get("id"),
        properties: {
          _BundleCollection: this.collectionId,
          _BundleConfiguration: JSON.stringify({
            bundleQuantity: this.bundleQuantity,  
            e_collection: btoa(this.collectionId),
          }),
        },
        title: formData.get("product_name"),
        price: Number(formData.get("price")) / 100,
        image: formData.get("product_image"),
        variantTitle,
        hkd: c,
      };
    this.productsInBundle.push(product),
      this.syncProductsInBundleWithStorage(),
      this.updateBundleUI();
  }
  removeProductFromBundle(product) {
    (this.productsInBundle = this.productsInBundle.filter(
      (p) => p.id !== product.id
    )),
      this.syncProductsInBundleWithStorage(),
      this.updateBundleUI();
  }
  toggleCart() {
    this.classList.contains("hidden")
      ? this.classList.remove("hidden")
      : this.classList.add("hidden");
  }
  updateBundleUI() {
    const list = document.getElementById("byb_product_list");
    if (!list) return;
    list.innerHTML = "";
    const emptyPlaceholderCount =
      this.bundleQuantity - this.productsInBundle.length;
    this.productsInBundle.forEach((product, index) => {
      const li = document.createElement("li");
      (li.dataset.id = product.id),
        li.classList.add("byb-bundle-item", "text-sm", "relative"),
        (li.innerHTML = `
          <div class="byb-cart-item flex items-center justify-between gap-2 bg-white rounded-sm overflow-hidden">
            <button class="byb-remove-bundle-item absolute text-xs ">${
              this.translations.Remove
            }</button>
            <img height="100" class="object-cover min-h-[80px] h-full" src="${
              product.image
            }" alt="${product.title}" />
            <div class="flex flex-col gap-2 pr-2 w-full">
              <span class="Heading font-bold text-sm">${
                product.title.trim().length > 22
                  ? product.title.trim().substring(0, 22) + "..."
                  : product.title.trim()
              }</span>
                <span class="flex flex-row item-center justify-between gap-x-2">
                ${
                  product.variantTitle
                    ? `<span class="text-sm">Size: ${product.variantTitle}</span>`
                    : ""
                }
                <span class="byb-before-price text-sm line-through">${
                  product.price + " " + this.currency
                }</span>
              </span>
            </div>
          </div>
          `),
        li.addEventListener("click", (event) => {
          if (event.target.classList.contains("byb-remove-bundle-item")) {
            const clickedIndex = this.productsInBundle.findIndex(
              (p) => p.id === product.id
            );
            clickedIndex !== -1 &&
              (this.productsInBundle.splice(clickedIndex, 1),
              this.syncProductsInBundleWithStorage(),
              this.updateBundleUI());
          }
        }),
        list.appendChild(li);
    });
    for (let i = 0; i < emptyPlaceholderCount; i++) {
      const emptyLi = document.createElement("li");
      emptyLi.classList.add("byb-bundle-item-empty"),
        (emptyLi.innerHTML = `
          <div class="flex flex-row md:flex-col items-center justify-center">
            <img width="45" loading="lazy" src="${placeholderImg}" alt="Bundle"  />
            <span class="text-sm text-gray-400">${this.translations.empty_item}</span>
          </div>
          `),
        list.appendChild(emptyLi);
    }
    this.calculateMpcd(),
      this.updateAvailableProducts(),
      this.renderCartDetail();
  }
  renderCartDetail() {
    const beforePrice = this.productsInBundle.reduce(
        (acc, product) => acc + product.price,
        0
      ),
      savedProcent =
        beforePrice !== 0
          ? Math.round(100 - ((this.bundlePrice*Shopify.currency.rate) / beforePrice) * 100)
          : 0,
      container = document.getElementById("byb_cart_details");
    if (!container) return;

     
    let buttonText = this.translations.add_bundle_to_cart,
      buttonClass = "Button Button_secondary";
    const remainingQuantity =
      this.bundleQuantity - this.productsInBundle.length;
    remainingQuantity === 0
      ? (buttonClass = "Button Button_primary")
      : remainingQuantity > 0 &&
        (buttonText = `${this.translations.select} ${remainingQuantity} ${
          this.translations.more
        } ${
          remainingQuantity === 1
            ? this.translations.item
            : this.translations.items
        }`);
    let amountSelected = 0;
    amountSelected = this.bundleQuantity - remainingQuantity;
    const bundleCountSpan = document.querySelector(".bundle-count");
    bundleCountSpan && (bundleCountSpan.innerHTML = amountSelected);
    const bundleCartButton = document.querySelector(".bundlecart_button");
    var finalPriceHere= this.bundlePrice*Shopify.currency.rate;
    remainingQuantity === 0 &&
      bundleCartButton &&
      bundleCartButton.classList.add("bundle_full"),
      (container.innerHTML = `
      <div class="byb-cart-price flex flex-col pb-2 mb-2">
          <span class="byb-your-price flex justify-between text-xl font-bold">${
            this.translations.your_price
          }: <span>${finalPriceHere.toFixed(2)} ${this.currency}</span></span>
          <span class="byb-before-price flex justify-between">${
            this.translations.before_price
          }: <span class="text-orange">${beforePrice.toFixed(2)} ${
        this.currency
      }</span></span>
          <span class="byb-saved flex justify-between">${
            this.translations.saving
          }: <span class="text-orange">${savedProcent}%</span></span>
      </div>
      <a href="#" id="add_bundle_to_cart" class="${buttonClass} w-full mt-4">${buttonText}</a>
      `),
      document
        .getElementById("add_bundle_to_cart")
        .addEventListener("click", (event) => {
          event.preventDefault(),
            remainingQuantity > 0
              ? this.toggleCart()
              : (this.addBundleToCart(), this.toggleCart());
        });

       if(savedProcent <= 0)
    {
     document.querySelector('.byb-saved').classList.add('hidden'); 
    }else{
     document.querySelector('.byb-saved').classList.remove('hidden');
    }
    
  }
  hideCartDetails() {
    const container = document.getElementById("byb_cart_details");
    container && (container.innerHTML = "");
  }
  extractHkd(formData) {
    const x = atob("WTI5emRB"),
      y = String(formData.get(x)),
      z = atob(y);
    return Number(z) / 8;
  }
  extractMhkd(mhkd) {
    const z = atob(mhkd);
    return Number(z) / 8;
  }
  cartIsOverLimit() {
    const thkd = this.productsInBundle.reduce(
      (acc, product) => acc + product.hkd,
      0
    );
    return this.mhkd - thkd < 0
      ? (alert("Something is wrong with the cart. Please try other products"),
        !0)
      : !1;
  }
  async addBundleToCart() {
    if (this.cartIsOverLimit()) return;
    const items = this.productsInBundle.map(function (product) {
      var prodId = parseInt(product.id);
        return { quantity: 1,id: prodId };
      }),
      ajax = window.liquidAjaxCart;
    this.enableLoading();
    const options = {
      firstCallback: (requestState) => {
        this.addToCardSuccesCallback(requestState),
          this.disableLoading(),
          document.body.classList.add("js-show-ajax-cart"),
          document.documentElement.classList.contains("js-ajax-cart-empty")
            ? document
                .querySelector("#shopify-section-cart-recomendations")
                .classList.remove("cart-recom-slidein")
            : document
                .querySelector("#shopify-section-cart-recomendations")
                .classList.add("cart-recom-slidein");
      },
    };

console.log(items);

    
var lastId = items[items.length-1].id;
document.querySelector('.sampleProduct form.form input.product-variant-id').value=lastId;
items.pop();
// now adding last item using dawn form
    
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {items},
dataType: 'json', 
success: function (data) { 

  //location.href="/cart";
 document.querySelector('.sampleProduct form.form button.custom-new-button').click();

},
error: function()
  {
alert("Please try again!")
  }
 }); 
   // ajax.add({ items: dataToSend }, options);
  }
  addToCardSuccesCallback(response) {
    if ((this.disableLoading(), response.responseData.status !== 200)) {
      this.disableLoading(), console.log("cart error", response);
      return;
    }
    (this.productsInBundle = []),
      this.syncProductsInBundleWithStorage(),
      this.updateBundleUI();
  }
  extractTranslations() {
    let trans = this.replaceAll(this.dataset.translations, "=>", ":");
    return (
      (trans = this.replaceAll(trans, "u0026quot;", '"')),
      (trans = this.replaceAll(trans, "=u0026gt;", ":")),
      JSON.parse(trans)
    );
  }
  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, "g"), replace).replace(/\\/g, "");
  }
  async fetchDiscounts() {
    this.enableLoading();
    const scriptConf = this.querySelector("script[data-configuration-json]"),
      configuration = JSON.parse(scriptConf?.innerHTML);
    (this.bundleQuantity = configuration.quantity),
      (this.bundlePrice = configuration.bundlePrice),
      (this.bundleName = configuration.bundleName),
      (this.mhkd = this.extractMhkd(configuration.mhkd)),
      (this.cpp = configuration.cpp),
      (this.cpp === null || this.cpp === 0) && this.calculateCheapestCpp(),
      this.fetchProductsInBundleWithStorage(),
      this.calculateMpc(),
      this.disableLoading();
  }
  enableLoading() {
    document.getElementById("byb_overlay")?.classList.remove("!hidden");
  }
  disableLoading() {
    document.getElementById("byb_overlay")?.classList.add("!hidden");
  }
  syncProductsInBundleWithStorage() {
    const storageData = { productsInBundle: this.productsInBundle };
    localStorage.setItem(
      "byb_products_in_bundle_" + this.collectionId,
      JSON.stringify(storageData)
    );
  }
  fetchProductsInBundleWithStorage() {
    const storageData = localStorage.getItem(
      "byb_products_in_bundle_" + this.collectionId
    );
    if (!storageData) return;
    const parsedData = JSON.parse(storageData);
    (this.productsInBundle = parsedData.productsInBundle),
      this.calculateMpc(),
      this.updateBundleUI();
  }
  calculateCheapestCpp() {
    const products = document
        .querySelector("#product-grid")
        ?.querySelectorAll(".Product-item"),
      prices = [];
    return (
      products?.forEach((product) => {
        const productForm = product.querySelector("form"),
          formData = new FormData(productForm),
          hkd = this.extractHkd(formData);
        prices.push(hkd);
      }),
      (this.cpp = Math.min(...prices)),
      this.cpp
    );
  }
  calculateMpc() {
    const cbd = this.mhkd - this.cpp * this.bundleQuantity;
    (this.mpc = this.cpp + cbd), (this.mpcd = this.mpc);
  }
  calculateMpcd() {
    const remainingProductsQty =
        this.bundleQuantity - this.productsInBundle.length,
      thkd = this.productsInBundle.reduce(
        (acc, product) => acc + product.hkd,
        0
      ),
      cbdRemaining = this.mhkd - thkd - this.cpp * remainingProductsQty;
    this.mpcd = this.cpp + cbdRemaining;
  }
  updateAvailableProducts() {
    const grid = document.querySelector("#product-grid"),
      thkd = this.productsInBundle.reduce(
        (acc, product) => acc + product.hkd,
        0
      );
    let dhkd = this.mhkd - thkd;
    (dhkd = dhkd - this.cpp), dhkd < this.cpp && (dhkd = this.cpp);
    let mpcIndex = 0,
      mpcdIndex = 0;
    grid?.querySelectorAll(".Product-item")?.forEach((product) => {
      const productForm = product.querySelector("form"),
        formData = new FormData(productForm),
        productId = formData.get("id"),
        hkd = this.extractHkd(formData),
        inCart = this.productsInBundle.find((p) => p.id === productId),
        exceedsBudget = hkd > dhkd || hkd > this.mpc || hkd > this.mpcd,
        removeButton = product.querySelector(".byb-remove-bundle-item");
      removeButton &&
        removeButton.addEventListener("click", () => {
          const clickedProductIndex = this.productsInBundle.findIndex(
            (p) => p.id === productId
          );
          clickedProductIndex !== -1 &&
            (this.productsInBundle.splice(clickedProductIndex, 1),
            this.syncProductsInBundleWithStorage(),
            this.updateBundleUI());
        }),
        exceedsBudget
          ? product.classList.add("hide")
          : product.classList.remove("hide");
    });
  }
}
customElements.define("build-your-bundle-cart", BuildYourBundleCart);
//# sourceMappingURL=/cdn/shop/t/65/assets/build-your-bundle.js.map?v=139955053648592848871713270495















